//Dependencies
import React, { Component } from 'react';
import moment from 'moment';
import {connect} from 'react-redux';

//material-ui
import Grid from '@material-ui/core/Grid';

import legales from './Legales';

class Footer extends Component {
    constructor(props) {
        super(props);
        this.legal = this.legal.bind(this);
        this.legalesConfirmar = this.legalesConfirmar.bind(this);
    }

    legalesConfirmar(){
        if( typeof this.props.dataLanding.parametria !== "undefined" && Object.keys(this.props.dataLanding.parametria).length === 0 )
            return "";

        const {parametria} = this.props.dataLanding;
        const url = window.location.hostname + window.location.pathname;
        const tna = Number(parametria.tna).toFixed(2);
        const tea = Number(parametria.tea).toFixed(2);
        const tnaUVA = Number(parametria.tnaUVA).toFixed(2);
        const teaUVA = Number(parametria.teaUVA).toFixed(2);
        const plazoMinimo = moment(parametria.inicioVigencia).utc().format('DD/MM/YYYY');
        const plazoMaximo = moment(parametria.finVigencia).utc().format('DD/MM/YYYY');
        const montoGarantia = '$50.000.000';

        const legalesNuevo = ` PUBLICIDAD. CARTERA CONSUMO. (1) TASA NOMINAL ANUAL (T.N.A.) ${tna}% . TASA EFECTIVA ANUAL (T.E.A.) ${tea}% CORRESPONDIENTE A UN EJEMPLO DE DEPÓSITO A PLAZO FIJO TRADICIONAL DE $5.000 A 30 DÍAS. (2) TASA NOMINAL ANUAL (T.N.A.) ${tnaUVA}% . TASA EFECTIVA ANUAL (T.E.A.) ${teaUVA}%. CORRESPONDIENTE A UN EJEMPLO DE DEPÓSITO A PLAZO FIJO (PF) CONFORME COMUNICACIÓN BCRA A 6871 Y SUS MODIFICATORIAS EN UNIDADES DE VALOR ADQUISITIVO ACTUALIZABLES POR "CER"- LEY 25.827 ("VA") DE $1.000 A 90 DÍAS. DICHAS TASAS PODRÁN VARIAR EN FUNCIÓN DEL MONTO Y PLAZO DEL DEPÓSITO A PLAZO FIJO QUE EL CLIENTE FINALMENTE CONSTITUYA. VIGENCIA DE TASAS DESDE EL ${plazoMinimo} HASTA EL ${plazoMaximo} INCLUSIVE, SOLO PARA PERSONAS HUMANAS MAYORES DE EDAD QUE CONSTITUYAN UN DEPOSITO NUEVO A PLAZO FIJO (PF) REGISTRANDOSE EN EL PRESENTE SITIO: WWW.BUHOBANK.COM/ONBOARDING/. NO APLICA PARA RENOVACIONES DE PF EXISTENTES, CLIENTES CON PRODUCTOS ACTIVOS, NI EMPLEADOS DE BANCO HIPOTECARIO SA. MONTO MÍNIMO POR DEPÓSITO: $5.000. MONTO ESTIMADO CONFORME LA COTIZACIÓN ACTUAL DE UVA. AL VENCIMIENTO DEL PF EL MONTO INICIAL SERÁ ACTUALIZADO A LA COTIZACIÓN UVA VIGENTE SOBRE EL QUE SE CALCULARAN LOS INTERESES A COBRAR, EN CASO DE CORRESPONDER. CONSULTE COTIZACIÓN DE UVA EN WWW.BCRA.COM.AR. LOS PF PODRÁN SER CANCELADOS ANTICIPADAMENTE A PARTIR DE TRANSCURRIDOS 30 DÍAS CORRIDOS Y CON PREAVISO DE 1DÍA HABIL DE ANTELACIÓN. EN CASO DE HACERLO, NO SE TOMARÁ COMO REFERENCIA LA COTIZACIÓN UVA; Y EL MONTO INICIAL MÁS LOS INTERESES A COBRAR SE CALCULARÁN EN BASE A LA FECHA DE CANCELACIÓN ANTICIPADA CON UNA TNA DE 10.00% Y TEA 10.47%. LOS DEPÓSITOS EN PESOS Y EN MONEDA EXTRANJERA CUENTAN CON LA GARANTÍA DE HASTA ${montoGarantia}. EN LAS OPERACIONES A NOMBRE DE DOS O MÁS PERSONAS, LA GARANTÍA SE PRORRATEARÁ ENTRE SUS TITULARES. EN NINGÚN CASO, EL TOTAL DE LA GARANTÍA POR PERSONA Y POR DEPÓSITO PODRÁ EXCEDER DE ${montoGarantia}, CUALQUIERA SEA EL NÚMERO DE CUENTAS Y/O DEPÓSITOS. LEY 24.485, DECRETO Nº 540/95 Y MODIFICATORIOS Y COM. "A" 2337 Y SUS MODIFICATORIAS Y COMPLEMENTARIAS. SE ENCUENTRAN EXCLUIDOS LOS CAPTADOS A TASAS SUPERIORES A LA DE REFERENCIA CONFORME A LOS LÍMITES ESTABLECIDOS POR EL BANCO CENTRAL, LOS ADQUIRIDOS POR ENDOSO Y LOS EFECTUADOS POR PERSONAS VINCULADAS A LA ENTIDAD FINANCIERA. BANCO HIPOTECARIO S.A. CUIT N° 30-50001107-2. RECONQUISTA 151. CABA.
        `
        
        return legalesNuevo;
    }

    legal() {
        switch (this.props.active) {
            case 0:
                return legales.InformacionObligatoria;
            case 1:
                return legales.datosPersonales;
            case 2:
                return legales.domicilio;
            case 3:
                return this.legalesConfirmar();
        }
        return legales.confirmar;
    }

    render() {
        return (
            <div className="footer">
                <div className="footer-container">
                    <Grid container >
                        <Grid  item xs={12} >
                            {this.legal()}
                        </Grid>
                    </Grid>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state)=>{
    return ({
        dataLanding: state.plazoFijoLandingPage,
        simulacion: state.plazoFijoSimulador
    });
}

export default connect(mapStateToProps)(Footer);




// WEBPACK FOOTER //
// ./src/components/PlazoFijo/datosPersonales/components/Footer.js